import {LoadingScreen} from './services/LoadingScreen';
import './index.css';
import {AirBridgeImpl} from './services/AirBridgeImpl';
import {ActionFactory} from './actions/ActionFactory';
import {IntegrationApp} from './IntegrationApp';
import {DevIntegrationApp} from './DevIntegrationApp';
import {IApplication} from './IApplication';
import { ToastMessage } from 'services/ToastMessage';

// tslint:disable-next-line:no-console
console.log('FLASH INTEGRATION:CHECK');

let application: IApplication = new IntegrationApp(
    window,
    new LoadingScreen(document.getElementById('loading-screen')),
    new ToastMessage(document.getElementById('toaster') as HTMLDivElement),
    new ActionFactory(new AirBridgeImpl(window)),
);

if ('qa' === process.env.STAGE) {
    application = new DevIntegrationApp(application, window);
}

application.run();
